export const COOKIE_PARAM_NAME = {
    SESSION_UUID: 'sniff_session_uuid',
    REDIRECT: 'redirect_uri',
    REDIRECT_ONBOARD: 'redirect_onboard_uri',
    SUBSCRIBE: 'subscribe',
    USER: 'user',
    SNIFF_APP_DOWNLOAD_BANNER: 'sniff_app_download_banner',
    SNIFF_APP_SHOW_BANNER: 'sniff_app_show_banner',
    SMARTBANNER_INSTALLED: 'smartbanner-installed',
    SMARTBANNER_CLOSED: 'smartbanner-closed',
    FILTERS: 'filters',
    SEARCH_FILTERS: 'search_filters',
    SEARCH_FILTERS_AVAILABILITY: 'search_filters_availability',
    SEARCH_FILTERS_LOCATION: 'search_filters_location',
    SEARCH_FILTERS_MISC: 'search_filters_misc',
    SIGN_UP_FROM: 'sniff_sign_up_from',
    VISIT_LIST_FILTERS: 'visit-list-filters',
    RESERVATION_LIST_FILTERS: 'reservation-list-filters',
    SPOT_DATA_FILTER: 'spot-data-filter',
    REDIRECT_GOOGLE_CAL: 'sniff_sync_google_redirect_uri',
    SNIFF_FIRST_CLICK: 'sniff_first_click_4028',
    // Test
    FRONT_INTERSTITIAL_BEFORE_CALENDAR_FROM: 'sniff_interstitial_before_calendar_v2_5654_from',
    FRONT_SPECIFIC_TIME_FILTER: 'sniff_specific_time_filter_v6_5739',
    FRONT_OPTIONAL_INTER_SNIFFPASS: 'sniff_optional_inter_sniffpass_v2_5916',
    FRONT_ENHANCED_REVIEW: 'sniff_enhanced_review_5957',
    FRONT_SNIFFPASS_HOMEPAGE: 'sniff_sniffpass_homepage_5961',
    FRONT_NON_AUTH_REVIEW_V2: 'sniff_non_auth_review_v2_5671',
    FRONT_TWO_HOURS_WARN: 'sniff_front_two_hours_warn_6039',
    FRONT_SPOT_LAST_ACTIVE: 'sniff_spot_last_active_6101',
    FRONT_SPOT_DETAIL_FAQS: 'sniff_spot_detail_faqs_6125',
    FRONT_SMALL_DOG_FENCING: 'sniff_small_dog_fencing_6115',
    FRONT_RECENT_REVIEWS: 'sniff_recent_reviews_6043',
    FRONT_SEARCH_60_MI: 'sniff_search_sixty_miles_v3_6131',
    BACK_SEARCH_LOC_DISTANCE: 'sniff_search_loc_distance_5880',
    FRONT_AVAILABILITY_QUICK_FILTER: 'sniff_availability_quick_filter_v2_5996',
    FRONT_BRONZE_NO_DISC: 'sniff_bronze_no_disc_6185',
    FRONT_LOCATION_REQUEST: 'sniff_location_request_6173',
    FRONT_LOCATION_SAVED: 'sniff_location_saved',
    LOCATION_MODAL_DISMISSED: 'sniff_location_modal_dismissed',
};
